var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpenAttempt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75H6.66667C4.70248 3.75 3.72039 3.75 3.11019 4.36019C2.5 4.97039 2.5 5.95248 2.5 7.91667V12.0833C2.5 14.0475 2.5 15.0296 3.11019 15.6398C3.72039 16.25 4.70248 16.25 6.66667 16.25H7.5",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.39635C7.5 3.48484 7.5 2.52909 8.08938 2.0066C8.67875 1.4841 9.57961 1.64123 11.3813 1.95548L13.322 2.29396C15.3174 2.64199 16.3151 2.81601 16.9075 3.5479C17.5 4.27978 17.5 5.33828 17.5 7.45527V12.5434C17.5 14.6604 17.5 15.7189 16.9075 16.4508C16.3151 17.1827 15.3174 17.3567 13.322 17.7047L11.3813 18.0432C9.57961 18.3575 8.67875 18.5146 8.08938 17.9921C7.5 17.4696 7.5 16.5139 7.5 14.6023V5.39635Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16602V10.8327",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenAttempt);
export default __webpack_public_path__ + "static/media/DoorOpenAttempt.1a856f11f1bf6430e5951eccaa21e2e2.svg";
export { ForwardRef as ReactComponent };